import { selectFeatures } from '@lifeomic/phc-web-toolkit/src/redux/modules/features/selectors';
import { useSelector } from 'react-redux';
import { Features, FeatureSuggestion } from './types';

const formatFeatureToSuggestion = (
  key: string,
  prefix: string,
): FeatureSuggestion => ({
  value: key,
  display: `${prefix} ${key}`,
  type: 'featureToggle',
});

const getEnabledFeatures = (features: Features): FeatureSuggestion[] =>
  Object.keys(features)
    .filter(key => features[key])
    .map(key => formatFeatureToSuggestion(key, 'Disable: '));

const getDisabledFeatures = (features: Features): FeatureSuggestion[] =>
  Object.keys(features)
    .filter(key => !features[key])
    .map(key => formatFeatureToSuggestion(key, 'Enable: '));

const filterFeatureSuggestions = (
  suggestions: FeatureSuggestion[],
  value: string,
): FeatureSuggestion[] => {
  const sections = value.trim().split(' ');
  const typedFeatureValue = sections[1];
  if (!typedFeatureValue) return suggestions;
  return suggestions.filter(suggestion =>
    suggestion.value.toLowerCase().includes(typedFeatureValue.toLowerCase()),
  );
};

const featureTogglesKeywords = ['enable', 'disable'];

export const useFeatureSuggestions = (searchValue: string) => {
  const features = useSelector(selectFeatures);
  const featureToggles = searchValue.startsWith(featureTogglesKeywords[0])
    ? getDisabledFeatures(features)
    : searchValue.startsWith(featureTogglesKeywords[1])
    ? getEnabledFeatures(features)
    : [];
  const featureMatches = filterFeatureSuggestions(featureToggles, searchValue);
  return featureMatches;
};
